import { unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { QuillEditor } from '@vueup/vue-quill';
import ImageUploader from 'quill-image-uploader';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ref, toRefs } from 'vue';
import { uploadImage } from '@/common/service/ImageUploadService';
import AppgInput from '@/components/custom/AppgInput.vue';
import { getImagePath } from '@/common/utils/Util';
export default {
  __name: 'AppgEditor',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      default: true
    },
    _class: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    invalidMessage: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '20rem'
    },
    validSet: {
      type: Object,
      default: () => ({
        $error: false
      })
    }
  },
  emits: ['update:modelValue', 'rawValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      modelValue,
      label,
      valid,
      invalidMessage,
      placeholder,
      required,
      width,
      height,
      validSet
    } = toRefs(props);
    const emit = __emit;
    const modules = {
      name: 'imageUploader',
      module: ImageUploader,
      options: {
        upload: file => new Promise((resolve, reject) => {
          setTimeout(async () => {
            const {
              status,
              data
            } = await uploadImage(file);
            let url = data?.storedFileName ?? '';
            let isOk = status === 200;
            if (data.entity) {
              url = data.entity.storedFileName;
              isOk = data.code === 1;
            }
            if (isOk) {
              resolve(getImagePath(url, 'origin', false));
            } else {
              reject('');
            }
          }, 300);
        })
      }
    };
    const quil = ref();
    const change = val => {
      emit('rawValue', quil.value.getText());
      emit('update:modelValue', val);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AppgInput, {
        label: _unref(label) ?? '',
        required: _unref(required),
        valid: _unref(valid),
        "in-valid-message": _unref(invalidMessage) ?? '필수 항목입니다.',
        "valid-set": _unref(validSet),
        _class: __props._class
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([{
            editor: !_unref(valid)
          }]),
          style: {
            "width": "100%"
          }
        }, [_createVNode(_unref(QuillEditor), {
          ref_key: "quil",
          ref: quil,
          style: _normalizeStyle(`width: ${_unref(width) ?? '100%'}; height: ${_unref(height) ?? '300px'}`),
          modules: modules,
          theme: "snow",
          content: _unref(modelValue),
          modelValue: _unref(modelValue),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
          toolbar: "full",
          "content-type": 'html',
          "onUpdate:content": change,
          class: _normalizeClass(__props._class),
          placeholder: _unref(placeholder) ?? '내용을 입력해주세요.'
        }, null, 8, ["style", "content", "modelValue", "class", "placeholder"])], 2)]),
        _: 1
      }, 8, ["label", "required", "valid", "in-valid-message", "valid-set", "_class"]);
    };
  }
};